// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2IFS4","col":"styles_col__2awKL"};